<template>
  <p class="mb-8">
    Visit our <a
      class="underline text-royal-blue-100 hover:text-royal-blue-160 focus:text-royal-blue-160 visited:text-visited"
      href="https://www.rsc.org/publishing/publish-with-us/publish-a-journal-article/chemical-science"
      target="_blank"
      id="lnk-author-guidelines"
    >
      guidelines</a> for help with your submission or <a
      class="underline text-royal-blue-100 hover:text-royal-blue-160 focus:text-royal-blue-160 visited:text-visited"
      :href="`mailto:manuscriptsupport@rsc.org?subject=RSC%20submissions%20query%20${submissionId}`"
      id="lnk-contact-support"
    >contact support</a>.
  </p>
</template>
<script setup lang="ts">
import { useStore } from 'vuex'
const store = useStore()

const submissionId = store.state.activeSubmission.submissionId
</script>
